import debounce from 'lodash-es/debounce';
import { eventScope, } from '../utils/';
export function resizeHandler(scrollbar) {
    var addEvent = eventScope(scrollbar);
    addEvent(window, 'resize', debounce(scrollbar.update.bind(scrollbar), 300));
}
//# sourceMappingURL=resize.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/smooth-scrollbar/events/resize.js
// module id = null
// module chunks = 